export default function buildProjects(records) {
  const projects = [];

  records.forEach((record) => {
    const { fields } = record;

    if (fields.isDraft) {
      return;
    }

    if (fields.pic == null || 
      fields.tagList == null ||
      fields.content == null) {
      return;
    }

    const project = {
      engName: fields.engName,
      chtName: fields.chtName,
      picURL: fields.pic[0].url,
      tags: fields.tagList.split(','),
      sizeClass: fields.sizeClass,
      contentId: fields.content[0],
    }

    if (fields.logoPic) {
      project.logoPicURL = fields.logoPic[0].url;
    }

    if (fields.businessDesignPic) {
      project.businessDesignPicURL = fields.businessDesignPic[0].url;
    }

    projects.push(project);
  });

  return projects;
}



// WEBPACK FOOTER //
// ./src/utils/projects.js